<template>
  <div class="skeleton" :class="{ 'skeleton-loading': loading }">
    <v-skeleton-loader
      v-for="(item, i) in 9"
      ref="skeleton"
      :key="i"
      type="image, paragraph"
      class="homeEvents_skeleton"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'HomeEventsSkeleton',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: mapState({
    common: (state) => state.common,
  }),
};
</script>

<style lang="scss">
.homeEvents_skeleton {
  &_wrapper {
    padding-top: 1px;
  }
  border-top: 1px solid #d1d2d8;
  padding: 9px 10px 8px;
  display: flex;
  .v-skeleton-loader__image {
    height: 66px;
    width: 100px;
    margin-right: 10px;
  }
  .v-skeleton-loader__paragraph .v-skeleton-loader__text:nth-child(1) {
    width: 120px;
    margin: 2px 0 4px;
  }
  .v-skeleton-loader__paragraph {
    .v-skeleton-loader__text:nth-child(2),
    .v-skeleton-loader__text:nth-child(3) {
      width: 70px;
      border-radius: 3px;
      height: 19px;
    }
  }
}
</style>
